import { render, staticRenderFns } from "./SearchAdvancedComponent.vue?vue&type=template&id=197c22d0&"
import script from "./SearchAdvancedComponent.vue?vue&type=script&lang=js&"
export * from "./SearchAdvancedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports